import ItemsV3Adapter from '@square/dashboard-items-data/adapters/items-v3-base';
export default class ItemVariationVendorInfo extends ItemsV3Adapter {}